import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PageLoading } from '../../Components/Loading';
import { useExpandShortLink } from '../../Data/ShortLinks';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { useToasts } from '../../Components/Toasts';
import { useNewWindow, useRedirect } from '../../Services/helpers';

const RedirectShortLink = () => {
    const {code} = useParams();
    const {link} = useExpandShortLink(code);
    const {showError} = useToasts();
    const {go, Redirect}  = useRedirect();
    const newWindow = useNewWindow();

    useEffect(() => {
        if (!link) {
            return;
        }

        if (!link.url) {
            showError('Unable to expand short link');
            go('/');
            return;
        }

        // If the link IS getSoapy.com
        if (link.url.indexOf('app.getsoapy.co') !== -1 || link.url.indexOf('localhost:300') !== -1) {
            // And is NOT a hosted link (portal etc)
            if (link.url.indexOf('/hosted') === -1) {
                go(link.url.replace('https://app.getsoapy.com', '').replace('http://localhost:3000', ''));
                return;
            }
        }

        newWindow(link.url);
        go('/');

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [link]);

    return <>
        <TopBar title="Short link" />
        <Page>
            <PageLoading message="Redirecting..." />
        </Page>
        <Redirect />
    </>
}

export default RedirectShortLink;
